import React from 'react';

const SearchResultBox = ({ circle, hashedCompanyId = null }) => {
  return (
    <React.Fragment>
      <div key={circle.id} className="col-12 col-sm-12 col-md-6 col-lg-6 p-1">
        <div className="bg-white search-shadow2 pt-2 pb-2 rounded_20 h-100 w-100">
          <a
            href={
              hashedCompanyId
                ? `/community/${hashedCompanyId}/circle/` + circle.id
                : '/circle/' + circle.id
            }
            className="hov--default"
          >
            <div className="container">
              <div className="row d-flex">
                <div className="col-5 col-md-5 pr-0 pt-2 pb-2">
                  <div className="adjust-box2 adjust-box-1x1 content-align-center">
                    <img
                      data-src={circle.main_image_url}
                      alt={circle.name}
                      className="rounded_20 w-100 object-fit-contain adjust-box-inner lazyloaded bg-graydark3"
                      onError={(e) => {
                        e.target.src = '/images/ja2/img_noimage.gif';
                      }}
                      src={circle.main_image_url}
                    />
                  </div>
                </div>
                <div className="col-7 col-md-7">
                  <div className="p-1">
                    <h6
                      className={`mb-1 mt-1 text-fz-16px text-fz-bold w-100 line-2 ${
                        circle.is_company_owned
                          ? 'icon-tunagate_official_sm_before'
                          : ''
                      }`}
                    >
                      {circle.name}
                    </h6>
                    {circle.categories && (
                      <div className="w-100">
                        <ul
                          className="list-unstyled mb-0 w-100"
                          style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}
                        >
                          {circle.categories.map(function (category, index) {
                            return (
                              <p
                                key={index}
                                className="btn btn-outline-gray2 btn-sm--expand3 text-fz-xs p-1 mr-2 mb-0"
                              >
                                {category.name}
                              </p>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                    <div className="row no-gutters mt-1">
                      <span
                        className="text-fz-11px text-info pb-0 text-gray"
                        dangerouslySetInnerHTML={{
                          __html: circle.review_score_disp,
                        }}
                      ></span>
                      <span className="text-fz-11px text-info pl-1 pb-0 text-gray">
                        {circle.scored_review_count}件
                      </span>
                    </div>
                    <p className="text-fz-xs text-gray mt-2 mb-0 w-100 line-2">
                      {circle.about}
                    </p>
                    <div className="d-flex">
                      <p className="text-gray mt-1 mb-0 line-1 icon icon-area mr-0 text-fz-11px w-100">
                        <span className="">
                          {circle.countries_pref && !circle.special_circle_type
                            ? circle.countries_pref.name
                            : ''}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchResultBox;
